import { render, staticRenderFns } from "./refundRecord.vue?vue&type=template&id=586c6938&scoped=true"
import script from "./refundRecord.vue?vue&type=script&lang=js"
export * from "./refundRecord.vue?vue&type=script&lang=js"
import style0 from "./refundRecord.vue?vue&type=style&index=0&id=586c6938&prod&lang=scss"
import style1 from "./refundRecord.vue?vue&type=style&index=1&id=586c6938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586c6938",
  null
  
)

export default component.exports